module.exports = { id: "heart-outline", url: "/build/app/img/symbols.svg#heart-outline", viewBox: "", toString: function() { return this.url; } };